export default __webpack_public_path__ + "static/Americana-Font-Regular-afb7c96e9b76b0c455a0718bc3be2138.woff2";